<template>
  <v-form @submit.native.prevent="submit()">
    <v-text-field
      autofocus
      label="Login"
      name="login"
      prepend-icon="mdi-account"
      :error-messages="validationErrors.login"
      :disabled="loading"
      v-model="fields.login"
      @input="$v.fields.login.$touch()"
    />
    <v-text-field
      label="Password"
      name="password"
      prepend-icon="mdi-lock"
      counter
      :append-icon="passwdShown ? 'mdi-eye' : 'mdi-eye-off'"
      :type="passwdShown ? 'text' : 'password'"
      :hint="`Password must be at least ${minPasswdLength} characters length`"
      :error-messages="validationErrors.password"
      :disabled="loading"
      v-model="fields.password"
      @click:append="passwdShown = !passwdShown"
      @input="$v.fields.password.$touch()"
    />
    <v-row class="pt-10" justify="end" no-gutters>
      <v-btn
        class="mr-4"
        color="primary"
        type="submit"
        :disabled="loading"
      >
        {{ $t('page-sign-in.title-button') }}
      </v-btn>
    </v-row>
  </v-form>
</template>
<script>
import FormAbstract from '@/components/abstract/form'
import validationRules from './validation-rules.js'

export default {
  extends: FormAbstract,
  name: 'FormSignIn',
  validationRules,
  props: {
    minPasswdLength: {
      type: Number,
      default: 6
    }
  },
  data () {
    return {
      fields: {
        login: null,
        password: null
      },
      passwdShown: false
    }
  }
}
</script>
